import { UUID } from "@bitory-gmbh/nidavellir";
import { useTextblocksCatalogShowQuery } from "@/services/backend/textblocks/api/catalog-api";

export function CatalogName({ catalogId }: { catalogId: UUID }) {
  const { data } = useTextblocksCatalogShowQuery({ id: catalogId });

  return <span>{data?.name}</span>;
}
